import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import BarbersPageTabs from '../../barbers/barbersWrapper/barbersPageTabs';
import DeletedBarbersList from '../../barbers/deletedBarbersList/DeletedBarbersListContainer';
import SimpleHeader from '../../headers/simpleHeader';
import DeletedStaffList from './DeletedStaffListContainer';
import { t } from '../../../../modules/infra/i18n';

const DeletedStaffPage = ({
  canViewDeletedBarbers,
  canViewDeletedStaff,
}) => (
  <div>
    <SimpleHeader heading={t('barber:deleted_staff.page_heading')} />
    <div className="c-wrapper o-page-height">
      <BarbersPageTabs />
      { canViewDeletedBarbers && (
        <Fragment>
          <div className="c-heading c-heading--dark">{t('barber:deleted_staff.barbers_section')}</div>
          <DeletedBarbersList />
        </Fragment>
      )}
      { canViewDeletedStaff && (
        <Fragment>
          <div className="c-heading c-heading--dark">{t('barber:deleted_staff.staff_section')}</div>
          <DeletedStaffList />
        </Fragment>
      )}
    </div>
  </div>
);

DeletedStaffPage.propTypes = {
  canViewDeletedBarbers: PropTypes.bool.isRequired,
  canViewDeletedStaff: PropTypes.bool.isRequired,
};

export default DeletedStaffPage;
